import { Navigate } from 'react-router-dom'

import { useConfigurationProperties } from '../../../hooks'
import Availability from './Availability'

const AvailabilityRouter = () => {
  const { carrierAvailabilityIsEnabled } = useConfigurationProperties()
  return carrierAvailabilityIsEnabled ? <Availability /> : <Navigate to="../" />
}

export default AvailabilityRouter
